import styled, {css} from "styled-components";
import {styles} from "../../config";

export const proposalBoxExteriorWidth = `35px`;

export const ProposalPinImage = styled.img`
    top: 12px;
`;

export const proposalFontSize = `16px`;
export const proposalLineHeight = 1.2;
export const proposalLinesToShow = 2;

const proposalBoxAddress = css`
    line-height: ${proposalLineHeight};
    min-width: 98%;
    text-overflow: ellipsis;
    font-weight: 400;
    font-size: ${proposalFontSize};
    color: #555555;
    display: -webkit-box;
    max-width: 400px;
    max-height: calc(${proposalFontSize} * ${proposalLineHeight * proposalLinesToShow});
    -webkit-line-clamp: ${proposalLinesToShow};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: start;
    border: none;
    margin: 0;
    padding: 0;
`;

export const ProposalBoxAddressInput = styled.input`
    ${proposalBoxAddress};
`;

export const ProposalBoxAddressLabel = styled.label`
    ${proposalBoxAddress};
`;

export const ProposalBoxColumn = css`
    background-color: white;
`;

export const ProposalBoxLeftColumn = styled.div`
    ${ProposalBoxColumn};
    width: ${proposalBoxExteriorWidth};
    float: left;
    display: flex;
    justify-content: center;

    > img {
        z-index: 50;
    }
`;

export const ProposalBoxRightColumn = ProposalBoxLeftColumn;

export const ProposalBoxMiddleColumn = styled.div`
    ${ProposalBoxColumn};
    width: calc(100% - (${proposalBoxExteriorWidth} * 2));
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-height: 40px;
    justify-content: center;
`;

export const ProposalAddressLabel = styled.div`
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    padding: 0;
    line-height: 28px;
`;

export const OriginAddressLabel = ProposalAddressLabel.extend`
    color: ${styles.primaryColor};
`;

export const DestAddressLabel = ProposalAddressLabel.extend`
    color: ${styles.secondaryColor};
`;



// WEBPACK FOOTER //
// ./src/Components/Address/AddressesStyle.js